import { z } from 'zod';

import { StepColorEnum } from '../../enums';
import { uuidValidator } from '../../validators';
import { WordResponseSchema } from '../words';

export const WordGroupResponseSchema = z.object({
  color: z.nativeEnum(StepColorEnum),
  description: z.string().nullable(),
  id: uuidValidator,
  lastDate: z.date().nullable(),
  name: z.string(),
  nextDate: z.date().nullable(),
  userId: uuidValidator,
  words: z.array(WordResponseSchema).optional(),
});

export type IWordGroupResponseDto = z.infer<typeof WordGroupResponseSchema>;
